"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileAnalyticsService = void 0;
const app_1 = require("app");
const __1 = require("..");
const types_1 = require("../../TileGroup/types");
const groupTypesToTrackNavigation = [
    types_1.groupTypes.applications,
    types_1.groupTypes.caseStudy,
    types_1.groupTypes.product,
    types_1.groupTypes.solutions,
];
const navigationTrackItemTypeMapping = {
    [types_1.groupTypes.product]: 'Related products',
    [types_1.groupTypes.applications]: 'Related applications',
    [types_1.groupTypes.solutions]: 'Solutions',
    [types_1.groupTypes.caseStudy]: 'Case studies',
};
class TileAnalyticsService {
    constructor() {
        this.trackGTMEvents = (link, tileListItem, tileIndex, tileType, currentPage, totalItems, groupTypeAndEvent) => {
            if (!(0, app_1.isDataLayerSet)() || !link.url) {
                return;
            }
            let isRedirectScheduled = false;
            if (tileType === __1.TileTypeEnum.SearchResults || tileType === __1.TileTypeEnum.Product) {
                isRedirectScheduled = this.trackTileListItemClick(tileIndex, link, tileType, totalItems, currentPage, groupTypeAndEvent.ev);
            }
            else if (tileType === __1.TileTypeEnum.TileGroupContent &&
                this.isTileNavigationTrackingNeeded(groupTypeAndEvent.groupType)) {
                isRedirectScheduled = this.trackTileNavigation(link, groupTypeAndEvent.groupType, groupTypeAndEvent.ev);
            }
            const { title } = tileListItem;
            if (!title) {
                return;
            }
            if (this.isIPaperDomainLink(link)) {
                this.trackIPaperDomainLinkClick(title, link);
            }
            else if (app_1.UrlService.isUrlToFile(link.url, true)) {
                this.trackFileLinkClick(tileListItem, isRedirectScheduled, link, groupTypeAndEvent.ev);
            }
        };
        this.trackSearchResultClick = (item) => {
            if (!item._click) {
                return;
            }
            const { link } = item;
            const { url, payload } = item._click;
            const body = JSON.stringify(payload);
            const apiUrl = localStorage.getItem('searchApiUrl') || window.location.origin;
            const clickUrl = new URL(apiUrl).origin;
            if (link.newWindow) {
                this.clickUrlRequest(clickUrl, url, body);
            }
            else {
                localStorage.setItem('clickUrlPayload', JSON.stringify({ url, payload }));
            }
        };
        this.clickUrlRequest = (baseUrl, url, body) => {
            fetch(`${baseUrl}${url}`, {
                method: 'POST',
                body,
            }).finally(() => {
                localStorage.removeItem('clickUrlPayload');
            });
        };
        this.trackTileListItemClick = (tileIndex, link, tileType, totalItems, currentPage, ev) => {
            const gtmData = {
                clickUrl: link.url,
                linkPosition: tileIndex + 1,
                linkPage: currentPage + 1,
                numberOfResults: totalItems,
                tileListType: tileType,
            };
            if (!link.newWindow) {
                ev.preventDefault();
                app_1.GTM.tileListItem(gtmData, () => {
                    window.location.href = link.url;
                });
                return true;
            }
            else {
                app_1.GTM.tileListItem(gtmData);
            }
            return false;
        };
        this.trackTileNavigation = (link, groupType, ev) => {
            const gtmData = {
                linkType: navigationTrackItemTypeMapping[groupType],
                linkUrl: link.url,
            };
            if (!link.newWindow) {
                ev.preventDefault();
                app_1.GTM.navigation(gtmData, () => {
                    window.location.href = link.url;
                });
                return true;
            }
            else {
                app_1.GTM.navigation(gtmData);
            }
            return false;
        };
        this.isTileNavigationTrackingNeeded = (groupType) => {
            return groupTypesToTrackNavigation.indexOf(groupType) !== -1;
        };
        this.isIPaperDomainLink = (link) => {
            const iPaperDomain = app_1.ConfigService.GetIPaperDomain();
            return iPaperDomain && link.url.indexOf(iPaperDomain) > -1;
        };
        this.trackIPaperDomainLinkClick = (title, link) => {
            app_1.GTM.iPaper({
                name: title,
                url: link.url,
            });
        };
        this.trackFileLinkClick = (tileListItem, isRedirectScheduled, link, ev) => {
            const { documentType, segments, fileType, title } = tileListItem;
            const gtmData = {
                category: documentType,
                name: title,
                page: window.location.href,
                path: link.url,
                segment: segments && segments.length ? segments.join(', ') : null,
                type: fileType || app_1.UrlService.GetFileExtension(link.url),
                organization: segments && segments.length ? segments.join(', ') : null,
            };
            if (!link.newWindow && !isRedirectScheduled) {
                ev.preventDefault();
                return app_1.GTM.download(gtmData, () => {
                    window.location.href = link.url;
                });
            }
            app_1.GTM.download(gtmData);
        };
    }
}
const instance = new TileAnalyticsService();
exports.TileAnalyticsService = instance;
